var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 10.5078 10.3564",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 10.3564,
    opacity: 0,
    width: 10.5078,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 5.34668C0 6.81641 0.424805 8.4375 1.14258 9.69727C1.26465 9.90723 1.49414 9.96582 1.71387 9.84375C1.91895 9.73145 1.97754 9.50195 1.85059 9.27246C1.19629 8.08105 0.830078 6.66016 0.830078 5.34668C0.830078 2.63672 2.48535 0.830078 4.9707 0.830078C7.45117 0.830078 9.11133 2.63672 9.11133 5.34668C9.11133 6.66016 8.74023 8.08105 8.08594 9.27246C7.95898 9.50195 8.01758 9.73145 8.22266 9.84375C8.44238 9.96582 8.67676 9.90723 8.79395 9.69727C9.51172 8.4375 9.94141 6.81641 9.94141 5.34668C9.94141 2.13379 7.95898 0 4.9707 0C1.97754 0 0 2.13379 0 5.34668ZM1.52832 9.5752C1.68945 10.1367 2.16797 10.3955 2.73438 10.2344C3.2959 10.0732 3.55957 9.58496 3.39355 9.02344L2.69531 6.64062C2.53418 6.08398 2.05566 5.82031 1.48926 5.98145C0.927734 6.14746 0.664062 6.63086 0.830078 7.19727ZM8.4082 9.5752L9.10645 7.19727C9.27246 6.62598 9.01367 6.14746 8.44727 5.98145C7.88086 5.82031 7.40723 6.08398 7.24121 6.64062L6.54297 9.02344C6.37695 9.58984 6.64062 10.0732 7.20215 10.2344C7.77344 10.3955 8.24707 10.1367 8.4082 9.5752Z",
    fill: "#d1d5dc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadset);
export default __webpack_public_path__ + "static/media/headset.8e3ff2a5423ff525ab02a64fea17593d.svg";
export { ForwardRef as ReactComponent };